import { Badge, Box, Card, Container, Group, Paper, Stack, Text, Title, useMantineTheme } from '@mantine/core';

import { IconCamera, IconPhoto } from '@tabler/icons-react';

import { motion } from 'framer-motion';

import { PRIMARY_FONT } from '../../constants/fonts';

export function GallerySection() {
  const theme = useMantineTheme();
  return (
    <Box
      id="gallery"
      py={100}
      style={{
        background: 'linear-gradient(180deg, #f0fdf4 0%, #ffffff 50%, #fafafa 100%)',
        position: 'relative',
      }}
    >
      {/* Decorative background elements */}
      <Box
        style={{
          position: 'absolute',
          top: '25%',
          left: '10%',
          width: '160px',
          height: '160px',
          background: `radial-gradient(circle, rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.06) 0%, transparent 70%)`,
          borderRadius: '50%',
          zIndex: 0,
        }}
      />
      <Box
        style={{
          position: 'absolute',
          bottom: '15%',
          right: '5%',
          width: '200px',
          height: '200px',
          background: `radial-gradient(circle, rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.05) 0%, transparent 70%)`,
          borderRadius: '50%',
          zIndex: 0,
        }}
      />
      <Box
        style={{
          position: 'absolute',
          top: '70%',
          left: '20%',
          width: '120px',
          height: '120px',
          background: `radial-gradient(circle, rgba(${parseInt(theme.other.secondaryColor.slice(1, 3), 16)}, ${parseInt(theme.other.secondaryColor.slice(3, 5), 16)}, ${parseInt(theme.other.secondaryColor.slice(5, 7), 16)}, 0.1) 0%, transparent 70%)`,
          borderRadius: '50%',
          filter: 'blur(25px)',
          zIndex: 0,
        }}
      />

      <Container size="lg" style={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
          viewport={{ once: true }}
        >
          <Stack align="center" gap="lg" mb={60}>
          <Badge
              size="lg"
              variant="light"
              color={theme.other.titleColor}
              style={{
                fontSize: '0.9rem',
                padding: '8px 16px',
                fontWeight: 500,
              }}
            >
              Wspomnienia
            </Badge>

            <Title
              order={2}
              ta="center"
              style={{
                fontFamily: PRIMARY_FONT,
                fontSize: 'clamp(2.5rem, 6vw, 4rem)',
                fontWeight: 700,
                color: theme.other.titleColor,
                lineHeight: 1.2,
                marginBottom: '1rem',
              }}
            >
              Galeria zdjęć
            </Title>
          </Stack>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <Paper
            shadow="xl"
            radius="xl"
            p="xl"
            style={{
              maxWidth: 600,
              margin: '0 auto',
              background: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
            }}
          >
            <Stack align="center" gap="lg">
              {/* Icon container */}
              <Box
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '20px',
                  background: `rgba(${parseInt(theme.other.secondaryColor.slice(1, 3), 16)}, ${parseInt(theme.other.secondaryColor.slice(3, 5), 16)}, ${parseInt(theme.other.secondaryColor.slice(5, 7), 16)}, 0.2)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: `1px solid rgba(${parseInt(theme.other.secondaryColor.slice(1, 3), 16)}, ${parseInt(theme.other.secondaryColor.slice(3, 5), 16)}, ${parseInt(theme.other.secondaryColor.slice(5, 7), 16)}, 0.3)`,
                }}
              >
                <IconCamera size={40} color="#6b5b00" />
              </Box>

              <Stack align="center" gap="sm">
                <Text
                  size="xl"
                  ta="center"
                  fw={600}
                  style={{
                    color: '#1a1a1a',
                    fontFamily: PRIMARY_FONT,
                    letterSpacing: '-0.01em',
                  }}
                >
                  Zdjęcia już wkrótce!
                </Text>
                <Text
                  size="md"
                  ta="center"
                  c="dimmed"
                  maw={400}
                  style={{
                    lineHeight: 1.6,
                    fontFamily: PRIMARY_FONT,
                  }}
                >
                  Dodamy tutaj najpiękniejsze zdjęcia z naszego ślubu gdy tylko będą gotowe od
                  fotografa.
                </Text>
              </Stack>
            </Stack>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
}
